import React from 'react';
import styled from "styled-components";
import Fade from 'react-reveal/Fade';

function Section({title,decription,leftbtntext,rightbtntext,backgroundImg}) {

    

    return (
        <Wrap BgImage={backgroundImg}>
            <Fade bottom>
            <ItemText>
                <h1>{title}</h1>
                <p>{decription}</p>
            </ItemText>
            </Fade>
            <Fade bottom>
            <ButtonGroup>
                <LeftButton>
                {leftbtntext}
                </LeftButton>
                {rightbtntext && 
                 <RightButton>
                 {rightbtntext}
                  </RightButton>
                }
               
            </ButtonGroup>
            </Fade>

            <DownArrow src="/images/down-arrow.svg" />
        </Wrap>
    )
}

export default Section

const Wrap = styled.div`

width: 100vw;
height: 100vh;
background-size: cover;
background-position: center;
background-image: url('/images/model-s.jpg');
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: center;
background-image: ${props=>`url("/images/${props.BgImage}")`};


`

const ItemText = styled.div`
text-align: center;
padding-top: 15vh;

`

const ButtonGroup = styled.div`
display: flex;
margin-bottom: 30px;

@media (max-width: 760px){
    flex-direction: column;
}
`

const LeftButton = styled.button`
background-color: rgba(23, 26, 32, 0.8);
height: 40px;
width: 256px;
color: white;
display: flex;
justify-content: center;
align-items: center;
border-radius: 100px;
opacity: 0.8;
text-transform: uppercase;
cursor: pointer;
margin: 8px;


`

const RightButton = styled(LeftButton)`
background: white;
opacity: 0.6;
color: black;
`


const DownArrow = styled.img`

height: 40px;
margin-top: 20px;
overflow-x: hidden;
animation: animateDown infinite 1.5s;


`